/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';


export interface TenantRansomwareRecoveryDeactivationSpec { 
    vlcr_provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    vlcr_region: string;
}
export namespace TenantRansomwareRecoveryDeactivationSpec {
}


